import axios from 'axios';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { LogOut, Menu } from 'lucide-react';
import { useAuthStatus } from '../../hooks/useAuthStatus';
import { useOrgStore } from '../../store/useOrgStore';

export function TopBar({ onMenuClick }: { onMenuClick?: () => void }) {
  const navigate = useNavigate();
  const { status } = useAuthStatus();
  const reset = useOrgStore((s) => s.reset);

  const handleDisconnect = async () => {
    try {
      await axios.delete('/api/auth/logout', { withCredentials: true });
    } catch {
      // Best-effort: still clear client state.
    }
    reset();
    toast.success('Signed out');
    navigate('/connect', { replace: true });
  };

  return (
    <header className="h-14 border-b border-border bg-surface-1 px-4 lg:px-6 flex items-center justify-between text-sm">
      <div className="flex items-center gap-3 min-w-0">
        {onMenuClick ? (
          <button
            type="button"
            aria-label="Open navigation"
            onClick={onMenuClick}
            className="md:hidden text-neutral-500 hover:text-crux-light p-1 -m-1"
          >
            <Menu size={18} />
          </button>
        ) : null}
        {/* The org name, edition and production badge went with the
            live-session audit (TYR-216). The Salesforce sign-in is now only a
            sign-in, so the bar names the person, not the org. */}
        {status?.username ? (
          <span className="text-crux-light truncate">{status.username}</span>
        ) : null}
      </div>
      <div className="flex items-center gap-4 shrink-0">
        <button
          type="button"
          onClick={handleDisconnect}
          className="flex items-center gap-2 text-neutral-500 hover:text-crux-light transition-colors"
        >
          <LogOut size={14} />
          <span className="hidden sm:inline">Sign out</span>
        </button>
      </div>
    </header>
  );
}
